export default __webpack_public_path__ + "static/media/V470_CoC.fee06ca3.pdf";